import React from "react";

export default function ProjectCard({
    image,
    title,
    subtitle,
    onClick,
    as = "a",
    link = "#",
    ...props
}) {
    const Wrapper = as;
    return (
        <Wrapper
            href={link}
            className="project-card-visual"
            tabIndex={0}
            onClick={onClick}
            {...props}
        >
            <div className="project-card-visual__img-wrapper">
                <img src={image} alt={title} className="project-card-visual__img" />
                <div className="project-card-visual__overlay" />
            </div>
            <div className="project-card-visual__text">
                <h3 className="project-card-visual__title">{title}</h3>
                {subtitle && (
                    <div className="project-card-visual__subtitle">{subtitle}</div>
                )}
            </div>
        </Wrapper>
    );
}
